import { render } from "./CustomerBenefitsView.vue?vue&type=template&id=490d2b8c&scoped=true"
import script from "./CustomerBenefitsView.vue?vue&type=script&lang=js"
export * from "./CustomerBenefitsView.vue?vue&type=script&lang=js"

import "./CustomerBenefitsView.vue?vue&type=style&index=0&id=490d2b8c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-490d2b8c"]])

export default __exports__